import { render } from "./application.vue?vue&type=template&id=d0579c10"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"
script.render = render

export default script